
import { CalendarState, CalendarViewType } from "@/utils/calendar-state";
import Vue from "vue";
export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>CalendarState,
			required: true
		}
	},
	computed: {
		weekNumber():number | null {
			if (this.state.currentViewType == CalendarViewType.Month) {
				return null;
			}
			return this.state.getWeekNumber();
		}
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
